import React, { useContext } from "react";
import TextBaseV2 from "../../textBaseV2/TextBaseV2";
import { DataContext } from "../../../contexts/DataContext";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../hooks/useLanguage";

export default function TotalPrice() {
  const { totalPriceTicket } = useContext(DataContext);
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();

  return (
    <div className="flex flex-row items-center justify-between w-full p-3 mt-4 rounded-lg bg-primary-600 ">
      <p className="text-purple-600 text-body-1 lg:font-medium">{t("total")}</p>
      <p className="font-bold text-purple-600 text-title-1">
        {currentLanguage === "en"
          ? `${totalPriceTicket.toFixed(2)} SR`
          : `SR ${totalPriceTicket.toFixed(2)}`}
      </p>
    </div>
  );
}
